import { getIsMobile } from '@office-start/device-detection-utility';
import { useFullDaysSinceFirstVisit, useIsCommercialUser, useIsFirstUse, } from '@office-start/harmony-data-service';
import { useMemo } from 'react';
export var useShouldShowNewUserShelf = function () {
    var isFirstUse = useIsFirstUse();
    var daysSinceFirstVisit = useFullDaysSinceFirstVisit();
    var isCommercialUser = useIsCommercialUser();
    var isMobile = useMemo(function () {
        return getIsMobile();
    }, []);
    return useMemo(function () {
        // $TODO: isRecentVisit is calculated in Angular based on user profile service's ImpressionsSinceFirstVisit metric
        // being present: userProfileService.doesMetricExist(KnownInstrumentationEvents.ImpressionsSinceFirstVisit) <= 5
        // Since we don't have that service yet, We'll use 2 days as a proxy for now.
        var isRecentVisit = daysSinceFirstVisit > -1 && daysSinceFirstVisit <= 2;
        var shouldShowNewUserShelf = (isFirstUse || isRecentVisit) &&
            !isMobile &&
            isCommercialUser === true;
        return {
            shouldShowNewUserShelf: shouldShowNewUserShelf,
            state: shouldShowNewUserShelf
                ? isRecentVisit
                    ? 'collapsed'
                    : 'expanded'
                : undefined,
        };
    }, [isCommercialUser, isFirstUse, isMobile, daysSinceFirstVisit]);
};
//# sourceMappingURL=useShouldShowNewUserShelf.js.map